export default "__VITE_ASSET__DLSGMfiO__"